import { render, staticRenderFns } from "./documentation.vue?vue&type=template&id=d5e3134c&scoped=true&"
import script from "./documentation.vue?vue&type=script&lang=js&"
export * from "./documentation.vue?vue&type=script&lang=js&"
import style0 from "./documentation.vue?vue&type=style&index=0&id=d5e3134c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e3134c",
  null
  
)

component.options.__file = "documentation.vue"
export default component.exports